export default function CategoryBadge({ name, polarity, testid }) {
  let cls = "bg-neutral-200 text-neutral-700 border-neutral-300"; // unknown
  if (polarity === "positif") cls = "bg-emerald-600 text-white border-emerald-700";
  else if (polarity === "negatif") cls = "bg-red-600 text-white border-red-700";

  return (
    <span
      data-testid={testid}
      className={`inline-flex items-center px-2 py-0.5 text-[0.65rem] font-semibold uppercase tracking-wider border ${cls}`}
    >
      {name || "-"}
    </span>
  );
}
